module.exports = __webpack_public_path__ + "static/media/clock-icon.4f58e98d.svg";